import { accordionAnatomy as parts } from "@chakra-ui/anatomy";
export { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, useAccordionItemState, useAccordionContext } from "@chakra-ui/react";
const baseStyleContainer = {
    border: 'none',
    _last: {}
};
const baseStyleButton = {
    transitionProperty: 'common',
    transitionDuration: 'normal',
    fontSize: '1rem',
    py: 'spacing.s',
    px: 0,
    _focus: {
        border: 'none',
        boxShadow: 'none'
    },
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
    }
};
const baseStylePanel = {
    pt: 'spacing.s',
    px: 0,
    pb: 'spacing.m'
};
const baseStyleIcon = {
    fontSize: '1.25em'
};
const faqVariant = {
    button: {
        _focusVisible: {
            opacity: 0.7
        },
        _focus: {
            opacity: 0.7
        },
        _hover: {
            opacity: 0.7
        }
    }
};
const defaultVariant = {
    button: {
        _focusVisible: {
            bg: 'background.neutral.primary.hovered'
        },
        _hover: {
            bg: 'background.neutral.primary.hovered'
        }
    }
};
const baseStyle = {
    container: baseStyleContainer,
    button: baseStyleButton,
    panel: baseStylePanel,
    icon: baseStyleIcon
};
export const ThemedAccordion = {
    parts: parts.keys,
    baseStyle,
    variants: {
        faq: faqVariant,
        default: defaultVariant
    },
    defaultProps: {
        variant: 'default'
    }
};

//# sourceMappingURL=Accordion.js.map